<template>
  <basic-header pretitle="aqfer Universal Tag" title="Tag Reports" :compact="true" />
  <div class="container-fluid mt-3" id="tag_reports">
    <Tabs :tabs="tabItems">
      <template v-slot:tagReport>
        <div class="row class-menu mt-4">
          <div class="col-md-12">
            <div class="mb-2">Choose a Class</div>
            <button
              style="margin-right: 10px"
              key="all"
              @click="currentCls = null"
              class="btn card-header-title"
              :class="[!currentCls ? 'active btn-primary' : 'btn-secondary']"
            >
              All
            </button>
            <button
              style="margin-right: 10px"
              v-for="classItem in classItems"
              :key="classItem.cls == 'NA' ? 'default' : classItem.cls"
              @click="currentCls = classItem.cls"
              class="btn card-header-title"
              :class="[
                currentCls == classItem.cls ? 'active btn-primary' : 'btn-secondary',
              ]"
            >
              {{ classItem.cls == "NA" ? "default" : classItem.cls }}
            </button>
          </div>
        </div>
        <div class="row class-menu">
          <div class="col-md-3">
            <input-field
              label="Report"
              type="select"
              :options="reportOptions"
              v-model="reportType"
            />
          </div>
          <div class="col-md-3">
            <input-field
              label="Date(UTC)"
              type="select"
              :options="dateOptions"
              v-model="dateType"
            />
          </div>
          <div class="col-md-3 my-auto">
            <div class="custom-control form-switch">
              <input
                type="checkbox"
                class="form-check-input"
                id="customSwitch1"
                v-model="showDaySplit"
              />
              <label
                style="padding-left: 5px"
                class="form-check-label"
                for="customSwitch1"
                >Daily Report</label
              >
            </div>
          </div>
          <div class="col-md-3 my-auto text-end">
            <button class="btn btn-primary" @click="loadCounts">Generate</button>
          </div>
        </div>
        <div class="row class-menu">
          <div class="col-md-3" v-if="dateType == 'custom'">
            <input-field
              label="Start Date(UTC)"
              type="calendar"
              v-model="startDate"
              :inputConfig="config"
            />
          </div>
          <div class="col-md-3" v-if="dateType == 'custom'">
            <input-field
              label="End Date(UTC)"
              type="calendar"
              v-model="endDate"
              :inputConfig="config"
            />
          </div>
        </div>
        <div class="error" v-if="errMode">
          <p>{{ errMsg }}</p>
        </div>
        <div v-if="reportType == 'tag_type' && !errMode">
          <div class="row align-items-end justify-content-between mb-1">
            <div class="col-md-9"><h3 class="">Counts By Tag Type</h3></div>
            <div class="col">
              <div class="input-group float-end w-75">
                <span class="input-group-text">Threshold</span>
                <input
                  type="number"
                  class="form-control"
                  aria-label="limit"
                  v-model="threshold_tagType"
                  step="1000"
                />
              </div>
            </div>
          </div>
          <div class="">
            <div class="card" v-if="showDaySplitTable && showDaySplit">
              {{ currentCls }}
              <datatable
                :key="tagDailyColumns.length"
                :tableId="`dailyTagCountList-${currentCls || 'all'}`"
                :columns="tagDailyColumns"
                :data="filteredCountsPixel || []"
                :scrollX="true"
                :compact="true"
                @exportCSV="(data) => exportCSV('tagtype_day_counts', data)"
                :enableCSVExport="true"
                :showLoading="filteredCountsPixel === null"
              />
            </div>
            <div class="card" v-if="!showDaySplit">
              <datatable
                :key="tagColumns.length"
                :tableId="`tagCountList-${currentCls || 'all'}`"
                :columns="tagColumns"
                :data="filteredCountsPixel || []"
                :scrollX="true"
                :compact="true"
                @exportCSV="(data) => exportCSV('tagtype_count', data)"
                :enableCSVExport="true"
                :showLoading="filteredCountsPixel === null"
              />
            </div>
          </div>
          <div class="row align-items-end justify-content-between mb-1">
            <div class="col-md-9"><h3>Counts By Partner Domain</h3></div>
            <div class="col">
              <div class="input-group float-end w-75">
                <span class="input-group-text">Threshold</span>
                <input
                  type="number"
                  class="form-control"
                  aria-label="limit"
                  v-model="threshold_partnerBeacon"
                  step="1000"
                />
              </div>
            </div>
          </div>
          <div class="">
            <div class="card" v-if="showDaySplitTable && showDaySplit">
              <datatable
                :key="partnerDailyColumns.length"
                :tableId="`partnerDailyCountList-${currentCls}`"
                :columns="partnerDailyColumns"
                :data="filteredCountsPartnerBeacon || []"
                :scrollX="true"
                :compact="true"
                @exportCSV="(data) => exportCSV('partner_domain_day_counts', data)"
                :enableCSVExport="true"
                :showLoading="filteredCountsPartnerBeacon === null"
              />
            </div>
            <div class="card" v-if="!showDaySplit">
              <datatable
                :key="partnerColumns.length"
                :tableId="`partnerCountList-${currentCls}`"
                :columns="partnerColumns"
                :data="filteredCountsPartnerBeacon || []"
                :scrollX="true"
                :compact="true"
                @exportCSV="(data) => exportCSV('partner_domain_count', data)"
                :enableCSVExport="true"
                :showLoading="filteredCountsPartnerBeacon === null"
              />
            </div>
          </div>
          <div class="row align-items-end justify-content-between mb-1">
            <div class="col-md-9"><h3>Counts By Redirect Domain</h3></div>
            <div class="col">
              <div class="input-group float-end w-75">
                <span class="input-group-text">Threshold</span>
                <input
                  type="number"
                  class="form-control"
                  aria-label="limit"
                  v-model="threshold_redirect"
                  step="1000"
                />
              </div>
            </div>
          </div>
          <div class="">
            <div class="card" v-if="showDaySplitTable && showDaySplit">
              <datatable
                :key="directDailyColumns.length"
                tableId="redirectDailyCountList"
                :columns="directDailyColumns"
                :data="filteredCountsRedirectPixel || []"
                :scrollX="true"
                :compact="true"
                @exportCSV="(data) => exportCSV('redirect_domain_day_counts', data)"
                :enableCSVExport="true"
                :showLoading="filteredCountsRedirectPixel === null"
              />
            </div>
            <div class="card" v-if="!showDaySplit">
              <datatable
                :key="directColumns.length"
                tableId="redirectCountList"
                :columns="directColumns"
                :data="filteredCountsRedirectPixel || []"
                :scrollX="true"
                :compact="true"
                @exportCSV="(data) => exportCSV('redirect_domain_counts', data)"
                :enableCSVExport="true"
                :showLoading="filteredCountsRedirectPixel === null"
              />
            </div>
          </div>
        </div>
        <div v-if="reportType == 'country' && !errMode">
          <div class="row align-items-end justify-content-between mb-1">
            <div class="col-md-9"><h3 class="">Counts By Tag Type</h3></div>
            <div class="col">
              <div class="input-group float-end w-75">
                <span class="input-group-text">Threshold</span>
                <input
                  type="number"
                  class="form-control"
                  aria-label="limit"
                  v-model="threshold_country"
                  step="1000"
                />
              </div>
            </div>
          </div>
          <div class="">
            <div class="card" v-if="!showDaySplit && showCountryListTable">
              <datatable
                tableId="CountryCountList"
                :columns="countryColumns"
                :data="filteredCountsCountry || []"
                :scrollX="true"
                :compact="true"
                @exportCSV="(data) => exportCSV('Tag_country_counts', data)"
                :enableCSVExport="true"
                :showLoading="filteredCountsCountry === null"
              />
            </div>
            <div class="card" v-if="showDaySplit">
              <div class="row card-body">
                <div class="col-sm-2"><h3>Filters:</h3></div>
                <div class="col-sm-3">
                  <div class="input-container">
                    <label class="input-label">Country &nbsp;</label>
                    <select v-model="selectedCountry">
                      <option value="All:All">All</option>
                      <option
                        v-for="option in countriesUnique"
                        :key="option.cc"
                        :value="option.cc"
                      >
                        {{ option.cc }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-4" v-if="!splitByStatus">
                  <div class="input-container">
                    <label class="input-label">TagType &nbsp;</label>
                    <select v-model="selectedTag">
                      <option value="All:All">All</option>
                      <option
                        v-for="option in tagTypesUnique"
                        :key="option.tagtype"
                        :value="option.tagType"
                      >
                        {{ option.tagType }}
                      </option>
                    </select>
                  </div>
                </div>
                <!-- <div
                  :class="showsplitByStatusTable ? 'col-md-7' : 'col-md-3'"
                  class="my-auto text-end"
                >
                  <div class="custom-control form-switch">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      id="customSwitch2"
                      v-model="splitByStatus"
                    />
                    <label
                      style="padding-left: 5px"
                      class="form-check-label"
                      for="customSwitch2"
                      >Split By Status</label
                    >
                  </div>
                </div> -->
              </div>
              <div v-if="showCountryDailyTable && showDaySplit && !splitByStatus">
                <datatable
                  tableId="dailyCountryCountList"
                  :columns="dailyCountryColumns"
                  :data="filteredCountsCountry || []"
                  :scrollX="true"
                  :compact="true"
                  @exportCSV="(data) => exportCSV('Tag_day_country_counts', data)"
                  :enableCSVExport="true"
                  :showLoading="filteredCountsCountry === null"
                />
              </div>
              <div v-if="showsplitByStatusTable && showDaySplit && splitByStatus">
                <complexHeaderDatatable
                  :key="dailyCountryStatusColumns.length"
                  tableId="dailyCountrySplitCountList"
                  :columns="dailyCountryStatusColumns"
                  :scrollX="true"
                  :data="filteredSplitByStatusCount"
                  @exportCSV="
                    (data) => exportCSV('Tag_day_country_counts_by_status', data)
                  "
                  :enableCSVExport="true"
                  :showLoading="filteredSplitByStatusCount === null"
                />
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:lowLatency>
          <div class="row class-menu mt-4">
              <div class="col-md-12">
                  <div class="mb-2">Choose a Class</div>
                  <button
                      style="margin-right:10px"
                      key="all"
                      @click="currentClsLL = null"
                      class="btn card-header-title "
                      :class="[!currentClsLL? 'active btn-primary' : 'btn-secondary']"
                      >
                      All
                  </button>
                  <button
                      style="margin-right:10px"
                      v-for="classItem in classItems"
                      :key="classItem.cls == 'NA' ? 'default' : classItem.cls"
                      @click="currentClsLL = classItem.cls"
                      class="btn card-header-title "
                      :class="[currentClsLL == classItem.cls ? 'active btn-primary' : 'btn-secondary']"
                      >
                      {{ classItem.cls == "NA" ? "default" : classItem.cls }}
                  </button>
              </div>
          </div>
          <div class="card">
              <div class="card-body"> 
                  <div class="d-flex justify-content-between align-items-center mb-3">
                      <div class="d-flex justify-content-start align-items-center mb-2" style="gap: 10px;">
                          <div>
                              <label for="llversiondim">Version</label>
                              <select class="form-select form-control mt-2" v-model="lowLatencyVersionDimension" id="llversiondim" @change="handleLowLatencyVersionChange($event.target.value)">
                                  <option v-for="option in lowLatencyVersionDimensionOptions" :key="option.version" :value="option.value">
                                      {{ option.label }}
                                  </option>
                              </select>
                          </div>
                          <div>
                              <label for="llstartTime">Start Time</label>
                              <flat-pickr :config="timeConfigLL" class="flatpickr-alt-input form-control rounded mt-2" placeholder="Select Start Time"
                                  name="date" label="label" v-model="startTimeLL" id="llstartTime"/>
                          </div>
                          <div>
                              <label for="llendTime">End Time</label>
                              <flat-pickr :config="timeConfigLL" class="flatpickr-alt-input form-control rounded mt-2" placeholder="Select End Time"
                                  name="date" label="label" v-model="endTimeLL" id="llendTime"/>
                          </div>
                          
                          <!-- <input-field :inlineField="true" label="End Time" type="calendar" v-model="endTimeLL" :inputConfig="timeConfigLL" /> -->
                      </div>
                      <div class="d-flex align-items-center gap-3">
                          <div class="me-1">
                            <input-field :inlineField="false" label="Enable Reporting" type="checkbox" v-model="lowLatencyEnabled" :editable="true" @change="updateLowLatencyEnabled($event)"/>
                          </div>
                          <button class="btn btn-sm btn-primary" @click="refreshLowLatencyData" :disabled="lowLatencyRefreshing"> 
                              <div v-if="lowLatencyRefreshing" class="spinner-border spinner-border-sm" role="status">
                                  <span class="visually-hidden">Loading...</span>
                              </div>
                              <div v-else>
                                  Refresh
                              </div>
                          </button>
                      </div>
                  </div>
                  <div v-if="lowLatencyDataFiltered">
                      <CollapsibleTable
                          id="lowLatencyTable"
                          :data="lowLatencyDataFiltered || []"
                          :columns="lowLatencyColumns"
                          :groupBy="groupByColumns"
                          :collapsibleCol="collapsibleCol"
                          aggregateCol="count"
                      />
                  </div>
                  <div v-else class="text-center">
                      <span>No Data found!</span>
                  </div>
              </div>
          </div>
      </template>
    </Tabs>
  </div>
</template>

<script>
import BasicHeader from "../../components/BasicHeader.vue";
import axios from "axios";
import { mapActions, mapState } from "vuex";
import customParseFormat from "dayjs/plugin/customParseFormat";
import dayjs from "dayjs";
import Tabs from "../../components/Tabs.vue";
import CollapsibleTable from "../../components/CollapsibleTable.vue";
import InputField from "../../components/InputField.vue";
import Datatable from "../../components/Datatable.vue";
import complexHeaderDatatable from "../../components/ComplexHeaderDatatable";
import csv from "../../utils/tools/csv";
import flatPickr from 'vue-flatpickr-component';
import {
  sortKeysRecursively,
  getCountsData,
  generateDayAndHourAndRawMetricsTimeRanges,
} from "../../utils/counts";
dayjs.extend(customParseFormat);

export default {
  components: {
    BasicHeader,
    InputField,
    Datatable,
    complexHeaderDatatable,
    Tabs,
    CollapsibleTable,
    flatPickr
  },
  data() {
    return {
      currentCls: null,
      currentClsLL: null,
      selectedCountry: "All:All",
      selectedTag: "All:All",
      splitByStatus: false,
      showDaySplitTable: false,
      showsplitByTable: false,
      showsplitByStatusTable: false,
      showCountryListTable: false,
      showCountryDailyTable: false,
      reportOptions: [
        { label: "Tag Type", value: "tag_type" },
        { label: "Country", value: "country" },
      ],
      reportType: "tag_type",
      dateOptions: [
        {
          label: "Today(" + dayjs().format("YYYY-MM-DD") + ")",
          value: "today",
        },
        {
          label: "Yesterday(" + dayjs().subtract(1, "day").format("YYYY-MM-DD") + ")",
          value: "yesterday",
        },
        { label: "Custom Range", value: "custom" },
      ],
      config: {
        wrap: true,
        enableTime: true,
        dateFormat: "m-d-Y H",
        time_24hr: true,
      },
      dateType: "yesterday",
      today: dayjs().format("YYYYMMDD"),
      yesterday: dayjs().subtract(1, "day").format("YYYYMMDD"),
      startDate: dayjs().subtract(1, "day").hour(0).format("MM-DD-YYYY HH"),
      endDate: dayjs().subtract(1, "day").hour(23).format("MM-DD-YYYY HH"),
      startTime: dayjs().hour(0).format("HH"),
      endTime: dayjs().hour(23).format("HH"),
      tagColumns: [
        {
          data: "tagType",
          title: "Tag Type",
        },
        {
          data: "count",
          title: "Count",
        },
      ],
      tagDailyColumns: [],
      partnerDailyColumns: [],
      directDailyColumns: [],
      partnerColumns: [
        {
          data: "beaconId",
          title: "Beacon Id",
        },
        {
          data: "description",
          title: "Description",
        },
        {
          data: "partnerDomain",
          title: "Partner Domain",
        },
        {
          data: "count",
          title: "count",
        },
      ],
      directColumns: [
        {
          data: "partnerDomain",
          title: "Redirect Domain",
        },
        {
          data: "count",
          title: "Count",
        },
      ],
      countryColumns: [],
      dailyCountryColumns: [],
      dailyCountryStatusColumns: [],
      showDaySplit: false,
      threshold_tagType: 1000,
      threshold_partnerBeacon: 1000,
      threshold_redirect: 1000,
      threshold_country: 1000,
      countsPixel: [],
      countsPartnerBeacon: [],
      countsRedirectPixel: [],
      countsCountry: [],
      filteredCountsPixel: null,
      filteredCountsPartnerBeacon: null,
      filteredCountsRedirectPixel: null,
      filteredCountsCountry: null,
      filteredSplitByStatusCount: null,
      counts: {},
      dailyTagColumns: [],
      tagTypesUnique: [],
      countriesUnique: [],
      splitByStatusCounts: [],
      errMode: false,
      errMsg: "",
      tabItems: [
        {
          name: "Tag Reports",
          id: "id1",
          slot: "tagReport",
        },
        {
          name: "Tag Deployment Visibility",
          id: "id2",
          slot: "lowLatency",
          tooltip: "Report is updated every 5 minutes (when enabled) and displays data for the current day",
        },
      ],
      lowLatencyData: null,
      lowLatencyDataFiltered: null,
      lowLatencyColumns: [
        { data: "time", title: "time" },
        { data: "count", title: "count" },
      ],
      groupByColumns: [],
      collapsibleCol: null,
      lowLatencyRefreshing: false,
      lowLatencyEnabled: null,
      lowLatencyVersion: null,
      lowLatencyDimensions: null,
      lowLatencyVersionDimension: null,
      lowLatencyVersionDimensionOptions: null,
      excludeDims: new Set(["batch_id", "cid", "class", "version"]),
      currentTime: new Date(),
      startTimeLL: dayjs().subtract(2, 'hour').toDate(),
      endTimeLL: dayjs().toDate(),
    };
  },
  async beforeMount() {
    await this.$store.dispatch("aut/fetchAutProdClientData", this.cid).then(() => {
      this.initiateClass();
      this.loadCounts();
      this.getLLMetrics(this.clientData.lowLatencyCountsConfig.metricName);
      this.getLowLatencyData(false);
    });
  },
  async mounted() {
      this.intervalId = setInterval(() => {
          this.currentTime = new Date()
      }, 60 * 1000); // update max time configurable for low latency every minute
  },
  beforeUnmount() {
      if (this.intervalId) {
          clearInterval(this.intervalId);
      }
  },
  computed: {
    ...mapState({
      cid: (state) => state.currentClient.cid,
      clientData: (state) => state.aut.autProdClientData,
      classItems: (state) => state.aut.autProdClientData.classes?.items || [],
    }),
    timeConfigLL() {
        const now = new Date(this.currentTime);
        let minDate = new Date(now);
        minDate.setDate(minDate.getDate() - 1); // set minimum start time to 24 hrs ago
        return {
            wrap: true, 
            enableTime: true,
            enableSeconds: true,
            dateFormat: 'Y-m-d H:i:S',  
            altFormat: 'm-d-Y H',
            altInput: true, 
            time_24hr: true,
            minDate: minDate,
            maxDate: now.setSeconds(now.getSeconds() + 1),
        }
    }
  },
  watch: {
    dateType() {
      this.loadCounts();
    },
    currentCls() {
      this.loadCounts();
    },
    currentClsLL() {
        this.filterLLDataByClass();
    },
    showDaySplit(val) {
      this.loadCounts();
    },
    splitByStatus(val) {
      this.showSplitByStatus(val);
    },
    selectedCountry(val) {
      this.filterDailyCountsCountryTT(this.selectedTag, this.selectedCountry);
    },
    selectedTag(val) {
      this.filterDailyCountsCountryTT(this.selectedTag, this.selectedCountry);
    },
    threshold_country(val) {
      if (!this.showDaySplit) {
        this.filteredCountsCountry = this.countsCountry.filter((obj) => {
          return obj.total > val;
        });
      } else {
        this.filteredCountsCountry = this.countriesUnique.filter((obj) => {
          return obj.count > val;
        });
      }
    },
    threshold_tagType(val) {
      if (!this.showDaySplit) {
        this.filteredCountsPixel = this.countsPixel.filter((obj) => {
          return obj.count > val;
        });
      } else {
        this.filteredCountsPixel = this.tagTypesUnique.filter((obj) => {
          return obj.count > this.threshold_tagType;
        });
      }
    },
    threshold_partnerBeacon(val) {
      if (!this.showDaySplit) {
        this.filteredCountsPartnerBeacon = this.countsPartnerBeacon.filter((obj) => {
          return obj.count > val;
        });
      } else {
        this.filteredCountsPartnerBeacon = this.partnerDomainsUnique.filter((obj) => {
          return obj.count > this.threshold_partnerBeacon && obj.beaconId != "All";
        });
      }
    },
    threshold_redirect(val) {
      if (!this.showDaySplit) {
        this.filteredCountsRedirectPixel = this.countsRedirectPixel.filter((obj) => {
          return obj.count > val;
        });
      } else {
        this.filteredCountsRedirectPixel = this.redirectDomainsUnique.filter((obj) => {
          return obj.count > this.threshold_redirect;
        });
      }
    },
  },
  methods: { 
    ...mapActions({
        getMetricMetadata: "aut/getMetricMetadata",
    }),
    handleLowLatencyVersionChange(val) {
        let arr = val.split(" - ")
        if (arr.length != 2) return;
        this.lowLatencyVersion = arr[0];
        this.lowLatencyDimensions = arr[1].split(", ");
    },
    async getLLMetrics(metric) {
        this.lowLatencyVersionDimensionOptions = []
        await this.getMetricMetadata(metric).then((response) => {
            if (response?.data) {
                const versions = response.data[metric].versions;
                // for each version
                Object.entries(versions).forEach(([key, value]) => {
                    let dims = value.dimensions.filter((dim) => {
                        // filter some default dims
                        return !this.excludeDims.has(dim.name)
                    }).map(dim => dim.name).join(", ")
                    this.lowLatencyVersionDimensionOptions.push({
                        version: key,
                        label: `${key} - [${dims}]`,
                        value: `${key} - ${dims}`,
                    })
                });
            }
        }).catch((error)=> {
            let err = error.response?.data.error ? error.response.data.error : error.message;
            console.error("Error getting low latency metric metadata: ", err)
        })
    },
    filterLLDataByClass() {
        if (!this.lowLatencyData) return;
        if (!this.currentClsLL) {
            this.lowLatencyDataFiltered = JSON.parse(JSON.stringify(this.lowLatencyData)); // deep clone
            return;
        }
        this.lowLatencyDataFiltered = this.lowLatencyData.filter(item => item.class === this.currentClsLL)
    },
    getLowLatencyData(customVersion) {
      this.lowLatencyData = [];
      let headers = ["class", "time", "count"];
      const version = customVersion ? this.lowLatencyVersion : this.clientData.lowLatencyCountsConfig.metricVersion
      const metric = this.clientData.lowLatencyCountsConfig.metricName;
      let dimensions = customVersion ? this.lowLatencyDimensions : this.clientData.lowLatencyCountsConfig.dimensions
      this.lowLatencyEnabled = this.clientData.lowLatencyCountsConfig.activatedUntil ? true : false;
      if (!version || !dimensions || dimensions.length == 0) return;

      if (!customVersion) {
          let dimsStr = dimensions.join(", ");
          this.lowLatencyVersionDimension = `${version} - ${dimsStr}`
          this.handleLowLatencyVersionChange(this.lowLatencyVersionDimension)
      }

      // insert dimensions to request and response(display) headers
      headers.splice(1, 0, ...dimensions);
      this.lowLatencyColumns.splice(
        0,
        0,
        ...dimensions.map((dim) => {
          return { data: dim, title: dim };
        })
      );
      this.groupByColumns.splice(0, 0, ...dimensions);
      this.collapsibleCol = dimensions ? dimensions[0] : null;

      const startTimeUTC = dayjs(this.startTimeLL).utc().format('YYYY-MM-DD HH:mm:ss')
      const endTimeUTC = dayjs(this.endTimeLL).utc().format('YYYY-MM-DD HH:mm:ss')

      let countsPayload = {
        start_time: startTimeUTC,
        end_time: endTimeUTC,
        aggregate: true,
        filter_dimensions: {
          version: version,
        },
        metrics: {
          [metric]: {
            version: version,
            header: headers,
          },
        },
      };
      axios
        .post(
          `${this.$store.state.countsUrl}/v2/cids/${this.cid}/metrics/batch/query`,
          countsPayload,
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.accessToken}`,
            },
          }
        )
        .then((response) => {
          if (response.data?.data && Object.keys(response.data.data).length > 0) {
            const data = response.data.data[metric];
            for (const row of data.data) {
              const rowObj = {};
              for (let i = 0; i < row.length; i++) {
                rowObj[data.headers[i]] = row[i];
              }
              this.lowLatencyData.push(rowObj);
            }
            this.filterLLDataByClass();
          }
        });
    },
    async refreshLowLatencyData() {
      this.lowLatencyRefreshing = true;

      // reset to original values
      this.lowLatencyData = null;
      this.lowLatencyDataFiltered = null;
      this.collapsibleCol = null;
      this.lowLatencyColumns = [
        { data: "time", title: "time" },
        { data: "count", title: "count" },
      ];
      this.groupByColumns = [];
      await this.$store.dispatch("aut/fetchAutProdClientData", this.cid).then(() => {
        this.getLowLatencyData(true);
      });
      this.lowLatencyRefreshing = false;
    },
    async updateLowLatencyEnabled(enabled) {
        await axios.put(
            `${this.$store.state.autMgmtUrl}/v1/clients/${this.$store.state.currentClient.cid}/low_latency_counts/enabled/${enabled}`, {},
            {
                headers: {
                    Authorization: `Bearer ${this.$store.state.accessToken}`,
                },
            }
        ).then(() => {
            this.refreshLowLatencyData();
        })
    },
    async loadCounts() {
      let self = this;
      let clsString = "";
      this.errMode = false;

      this.filteredCountsPixel = null;
      this.filteredCountsPartnerBeacon = null;
      this.filteredCountsRedirectPixel = null;
      this.filteredCountsCountry = null;
      this.showCountryListTable = false;

      if (this.dateType == "today") {
        this.toDate = this.today;
        this.fromDate = this.today;
      } else if (this.dateType == "yesterday") {
        this.toDate = this.yesterday;
        this.fromDate = this.yesterday;
      } else if (this.dateType == "custom") {
        this.fromDate = dayjs(this.startDate, "MM-DD-YYYY HH", true).format("YYYYMMDD");
        this.startTime = dayjs(this.startDate, "MM-DD-YYYY HH", true).format("HH");
        this.toDate = dayjs(this.endDate, "MM-DD-YYYY HH", true).format("YYYYMMDD");
        this.endTime = dayjs(this.endDate, "MM-DD-YYYY HH", true).format("HH");
      }

      if (this.dateDiffInDays(this.fromDate, this.toDate) > 95) {
        this.errMsg = "Request Denied. Requested date range is more than 3 months.";
        this.errMode = true;
        return "";
      }

      if (this.currentCls) {
        clsString = "/clss/" + this.currentCls;
      }

      if (this.clientData && this.clientData.config.pidCounts == true) {
        this.getPidCounts = true;
      } else {
        this.getPidCounts = false;
      }

      // Daily Counts
      if (this.showDaySplit) {
        // axios
        //   .get(
        //     `${this.$store.state.countsUrl}/v1/latency/cids/${this.cid}${clsString}/from/${this.fromDate}/until/${this.toDate}?daily=true&bg=true`,
        //     {
        //       headers: {
        //         Authorization: `Bearer ${this.$store.state.accessToken}`,
        //       },
        //     }
        //   )
        //   .then(function (response) {
        //     self.watchCountsQuery(
        //       response.data.query_execution_id,
        //       "latency",
        //       30000,
        //       function (response) {
        //         axios
        //           .get(
        //             `${self.$store.state.countsUrl}/v1/latency/cids/${self.cid}${clsString}/from/${self.fromDate}/until/${self.toDate}?daily=true`,
        //             {
        //               headers: {
        //                 Authorization: `Bearer ${self.$store.state.accessToken}`,
        //               },
        //             }
        //           )
        //           .then(function (response) {
        //             self.countsLoadingLatency = false;
        //             self.countriesPBLatency = {};
        //             // Get all column indexes for data row from columnDefs
        //             let cIndex, ccIndex, dIndex, pdIndex, sIndex, tIndex;
        //             for (let i = 0; i < response.data.columnDefs.length; i++) {
        //               switch (response.data.columnDefs[i].name) {
        //                 case "date":
        //                   dIndex = i;
        //                   break;
        //                 case "tag_type":
        //                   tIndex = i;
        //                   break;
        //                 case "country_code":
        //                   ccIndex = i;
        //                   break;
        //                 case "partnerDomain":
        //                   pdIndex = i;
        //                   break;
        //                 case "load_status":
        //                   sIndex = i;
        //                   break;
        //                 case "count":
        //                   cIndex = i;
        //                   break;
        //               }
        //             }
        //             // use above indexes to extract data from array of data rows
        //             for (let i = 0; i < response.data.data.length; i++) {
        //               let obj = response.data.data[i];
        //               let ccode = obj[ccIndex].toUpperCase();
        //               if (
        //                 obj[cIndex].match(/\d+/) != null &&
        //                 obj[tIndex] === "partner_beacon" &&
        //                 !obj[pdIndex].includes("NA:")
        //               ) {
        //                 let count = parseInt(obj[cIndex]);
        //                 let key = obj[dIndex] + obj[pdIndex] + obj[ccIndex] + obj[sIndex];
        //                 let allKey = obj[dIndex] + "All:All" + obj[ccIndex] + obj[sIndex];
        //                 let colTotalKey = obj[dIndex] + obj[pdIndex] + "_" + obj[sIndex];
        //                 let colTotalAllKey = obj[dIndex] + "All:All" + "_" + obj[sIndex];
        //                 let rowTotalKey = obj[dIndex] + obj[pdIndex] + obj[ccIndex] + "_";
        //                 let rowTotalAllKey = obj[dIndex] + "All:All" + obj[ccIndex] + "_";
        //                 let allTotalKey = obj[dIndex] + obj[pdIndex] + "_" + "_";
        //                 let allTotalAllKey = obj[dIndex] + "All:All" + "_" + "_";
        //                 self.updateCountriesPBLatencyCounts(key, count);
        //                 self.updateCountriesPBLatencyCounts(colTotalKey, count);
        //                 self.updateCountriesPBLatencyCounts(rowTotalKey, count);
        //                 self.updateCountriesPBLatencyCounts(allTotalKey, count);
        //                 self.updateCountriesPBLatencyCounts(allKey, count);
        //                 self.updateCountriesPBLatencyCounts(colTotalAllKey, count);
        //                 self.updateCountriesPBLatencyCounts(rowTotalAllKey, count);
        //                 self.updateCountriesPBLatencyCounts(allTotalAllKey, count);
        //               }
        //             }
        //           });
        //       }
        //     );
        //   })
        //   .catch((error) => {
        //     this.errMode = true;
        //     if (error.response.data.error) this.errMsg = error.response.data.error;
        //     else this.errMsg = error.message;
        //   });
        let response;
        try {
          response = await this.aggCounts(
            this.currentCls,
            this.fromDate,
            this.toDate,
            this.startTime,
            this.endTime,
            false,
            true
          );
        } catch (error) {
          this.errMode = true;
          if (error.response.data.error) this.errMsg = error.response.data.error;
          else this.errMsg = error.message;
          return;
        }
        self.updateDailyReports(response);
        try {
          response = await this.aggCounts(
            this.currentCls,
            this.fromDate,
            this.toDate,
            this.startTime,
            this.endTime,
            true,
            true
          );
        } catch (error) {
          this.errMode = true;
          if (error.response.data.error) this.errMsg = error.response.data.error;
          else this.errMsg = error.message;
          return;
        }
        self.updateDailyReports(response);
      } else {
        //Counts between given time period
        this.showDaySplitTable = false;
        this.showCountryDailyTable = false;
        let response;

        try {
          response = await this.aggCounts(
            this.currentCls,
            this.fromDate,
            this.toDate,
            this.startTime,
            this.endTime,
            false
          );
        } catch (error) {
          this.errMode = true;
          if (error.response.data.error) this.errMsg = error.response.data.error;
          else this.errMsg = error.message;
          return;
        }
        this.updateReports(response);

        try {
          response = await this.aggCounts(
            this.currentCls,
            this.fromDate,
            this.toDate,
            this.startTime,
            this.endTime,
            true
          );
        } catch (error) {
          this.errMode = true;
          if (error.response.data.error) this.errMsg = error.response.data.error;
          else this.errMsg = error.message;
          return;
        }
        this.updateReports(response);
      }

      // Revisit Code if client data has pidCounts set
      // if (this.getPidCounts && this.reportType != "tagType") {
      //     this.loadPidCount();
      // }
    },
    updateReports(d) {
      let self = this;
      this.countsPartnerBeacon = [];
      this.countsPixel = [];
      this.countsRedirectPixel = [];
      this.countries = [];
      this.countsCountry = [];
      this.countryColumns = [];
      this.countryColumns.push({
        data: "country",
        title: "Country",
      });

      if (d["tagType_countryCode"]) {
        this.countsCountries = d.tagType_countryCode;
      }

      for (let cc in d.countryCode) {
        this.countries.push({
          country: cc,
          count: d.countryCode[cc],
        });
      }
      for (let cData in this.countsCountries) {
        this.countryColumns.push({
          data: cData,
          title: cData,
        });
      }

      for (const country of this.countries) {
        let countryData = {};
        countryData.country = country.country;
        let total = 0;
        for (let cData in this.countsCountries) {
          if (this.countsCountries[cData][country.country]) {
            countryData[cData] = this.countsCountries[cData][country.country];
          } else {
            countryData[cData] = 0;
          }
          total = total + countryData[cData];
        }
        countryData.total = total;
        this.countsCountry.push(countryData);
      }
      this.countryColumns.push({
        data: "total",
        title: "Total",
      });
      this.filteredCountsCountry = this.countsCountry.filter((obj) => {
        return obj.total > self.threshold_country;
      });

      this.appendCounts(d.tagType, this.countsPixel, "tagType");
      this.appendCounts(
        d.partnerBeacon,
        this.countsPartnerBeacon,
        "partnerDomain",
        "beaconId"
      );
      this.appendCounts(
        d.redirect,
        this.countsRedirectPixel,
        "partnerDomain",
        "beaconId"
      );

      this.filteredCountsPixel = this.countsPixel.filter((obj) => {
        return obj.count > this.threshold_tagType;
      });

      this.filteredCountsPartnerBeacon = this.countsPartnerBeacon.filter((obj) => {
        return obj.count > this.threshold_partnerBeacon;
      });

      this.filteredCountsRedirectPixel = this.countsRedirectPixel.filter((obj) => {
        return obj.count > this.threshold_redirect;
      });

      this.showCountryListTable = true;

      this.mergeCounts(this.countsPartnerBeacon, "beaconId", "partnerDomain");
    },

    updateDailyReports(d) {
      let self = this;
      this.showDaySplitTable = false;
      this.showCountryDailyTable = false;
      this.countsPartnerBeaconSP = [];
      this.countsPixelSP = [];
      this.countsRedirectPixelSP = [];
      this.dailyCountsCountries = [];
      this.countsCountriesTTSP = [];
      this.countsCountriesPBSP = [];
      this.tagTypesUnique = [];
      this.partnerDomainsUnique = [
        {
          count: 0,
          partnerDomain: "All",
          beaconId: "All",
        },
      ];

      this.tagDailyColumns = [];
      this.directDailyColumns = [];
      this.partnerDailyColumns = [];
      this.tagDailyColumns.push({
        data: "tagType",
        title: "Tag Type",
      });
      this.partnerDailyColumns.push(
        {
          data: "beaconId",
          title: "Beacon Id",
        },
        {
          data: "description",
          title: "Description",
        },
        {
          data: "partnerDomain",
          title: "Partner Domain",
        }
      );
      this.directDailyColumns.push({
        data: "redirectDomain",
        title: "Redirect Domain",
      });
      this.dailyCountryColumns = [];
      this.dailyCountryColumns.push({
        data: "cc",
        title: "Country",
      });
      this.redirectDomainsUnique = [];
      this.countriesUnique = [];
      var tempTtObj = {};
      var tempPdObj = {};
      var tempRdObj = {};
      var tempCcObj = {};
      for (let day in d) {
        if (this.$store.state.environment === "test" && day.substring(9) != "") {
          continue;
        }
        let dayStr = day.replace(/(\d{4})(\d{2})(\d{2})/, "$1-$2-$3");
        this.tagDailyColumns.push({ data: dayStr, title: dayStr });
        this.partnerDailyColumns.push({ data: dayStr, title: dayStr });
        this.directDailyColumns.push({ data: dayStr, title: dayStr });
        this.dailyCountryColumns.push({ data: dayStr, title: dayStr });
        this.countsPixelSP.push({
          day: dayStr,
          tagType: d[day].tagType,
        });
        this.countsPartnerBeaconSP.push({
          day: dayStr,
          partnerDomain: d[day].partnerBeacon,
        });
        this.countsRedirectPixelSP.push({
          day: dayStr,
          partnerDomain: d[day].redirect,
        });
        this.countsCountriesTTSP.push({
          day: dayStr,
          tagType_cc: d[day].tagType_countryCode,
        });
        this.countsCountriesPBSP.push({
          day: dayStr,
          partnerDomain_cc: d[day].partnerBeacon_countryCode,
        });
        this.transformCounts(d[day].tagType, tempTtObj);
        this.transformCounts(d[day].partnerBeacon, tempPdObj);
        this.transformCounts(d[day].redirect, tempRdObj);
        this.transformCounts(d[day].countryCode, tempCcObj);
      }

      this.tagDailyColumns.push({
        data: "count",
        title: "Count",
      });
      this.partnerDailyColumns.push({
        data: "count",
        title: "Count",
      });
      this.directDailyColumns.push({
        data: "count",
        title: "Count",
      });

      this.appendCounts(tempTtObj, this.tagTypesUnique, "tagType");
      this.appendCounts(
        tempPdObj,
        this.partnerDomainsUnique,
        "partnerDomain",
        "beaconId"
      );
      this.appendCounts(
        tempRdObj,
        this.redirectDomainsUnique,
        "redirectDomain",
        "beaconId"
      );
      this.appendCounts(tempCcObj, this.countriesUnique, "cc");
      let dupkeys = this.mergeCounts(
        this.partnerDomainsUnique,
        "beaconId",
        "partnerDomain"
      );
      this.mergeDuplicates(dupkeys, this.countsPartnerBeaconSP, "partnerDomain");
      this.mergeDuplicates(dupkeys, this.countsCountriesPBSP, "partnerDomain_cc");
      this.countsPixelSP.forEach((cPSP, i) => {
        self.tagTypesUnique.forEach((ttu) => {
          ttu[cPSP.day] = cPSP.tagType[ttu.tagType];
        });
      });

      this.countsRedirectPixelSP.forEach((cRPSP, i) => {
        self.redirectDomainsUnique.forEach((rdu) => {
          let k = rdu.beaconId + ":" + rdu.redirectDomain;
          rdu[cRPSP.day] = cRPSP.partnerDomain[k];
        });
      });

      this.countsPartnerBeaconSP.forEach((cPBSP, i) => {
        if (!self.countsPartnerBeaconSP[i].partnerDomain) {
          self.countsPartnerBeaconSP[i].partnerDomain = {};
        }
        self.countsPartnerBeaconSP[i].partnerDomain["All:All"] = 0;
        for (let key in cPBSP.partnerDomain) {
          if (key !== "All:All" && cPBSP.partnerDomain[key]) {
            self.countsPartnerBeaconSP[i].partnerDomain["All:All"] +=
              cPBSP.partnerDomain[key];
          }
        }
        self.partnerDomainsUnique.forEach((pdu) => {
          let k = pdu.beaconId + ":" + pdu.partnerDomain;
          if (cPBSP.partnerDomain[k]) {
            pdu[cPBSP.day] = self.countsPartnerBeaconSP[i].partnerDomain[k] || 0;
          }
          if (k == "All:All") {
            pdu.count += self.countsPartnerBeaconSP[i].partnerDomain[k];
          }
        });
      });

      this.countsCountriesTTSP.forEach((ccTTSP, i) => {
        if (!self.countsCountriesTTSP[i].tagType_cc) {
          self.countsCountriesTTSP[i].tagType_cc = {};
        }

        self.countsCountriesTTSP[i].tagType_cc["All:All"] = {};
        for (let key in ccTTSP.tagType_cc) {
          for (let k in ccTTSP.tagType_cc[key]) {
            if (key !== "All:All" && ccTTSP.tagType_cc[key][k]) {
              if (!self.countsCountriesTTSP[i].tagType_cc["All:All"][k]) {
                self.countsCountriesTTSP[i].tagType_cc["All:All"][k] =
                  ccTTSP.tagType_cc[key][k];
              } else {
                self.countsCountriesTTSP[i].tagType_cc["All:All"][k] +=
                  ccTTSP.tagType_cc[key][k];
              }
            }
          }
        }
      });

      this.countsCountriesPBSP.forEach((ccPBSP, i) => {
        if (!self.countsCountriesPBSP[i].partnerDomain_cc) {
          self.countsCountriesPBSP[i].partnerDomain_cc = {};
        }
        self.countsCountriesPBSP[i].partnerDomain_cc["All:All"] = {};
        for (let key in ccPBSP.partnerDomain_cc) {
          if (ccPBSP.partnerDomain_cc[key]) {
            for (let k in ccPBSP.partnerDomain_cc[key]) {
              if (key !== "All:All" && ccPBSP.partnerDomain_cc[key][k]) {
                if (!self.countsCountriesPBSP[i].partnerDomain_cc["All:All"][k]) {
                  self.countsCountriesPBSP[i].partnerDomain_cc["All:All"][k] =
                    ccPBSP.partnerDomain_cc[key][k];
                } else {
                  self.countsCountriesPBSP[i].partnerDomain_cc["All:All"][k] +=
                    ccPBSP.partnerDomain_cc[key][k];
                }
              }
            }
          }
        }
      });

      this.filteredCountsPixel = this.tagTypesUnique.filter((obj) => {
        return obj.count > this.threshold_tagType;
      });
      this.filteredCountsPartnerBeacon = this.partnerDomainsUnique.filter((obj) => {
        return obj.count > this.threshold_partnerBeacon && obj.beaconId != "All";
      });
      this.filteredCountsRedirectPixel = this.redirectDomainsUnique.filter((obj) => {
        return obj.count > this.threshold_redirect;
      });
      this.filterDailyCountsCountryTT("All:All", "All:All");
      this.showDaySplitTable = true;
      this.showCountryDailyTable = true;
    },

    filterDailyCountsCountryTT(tagType, country) {
      let self = this;

      this.countsCountriesTTSP.forEach((cCTTSP, i) => {
        self.countriesUnique.forEach((ccu) => {
          ccu[cCTTSP.day] = cCTTSP.tagType_cc[tagType][ccu.cc];
        });
      });
      this.filteredCountsCountry = this.countriesUnique.filter((obj) => {
        return country == "All:All"
          ? obj.count > this.threshold_country
          : obj.count > this.threshold_country && obj.cc == country;
      });
    },

    showSplitByStatus(splitByStatus) {
      let self = this;
      this.filteredSplitByStatusCount = null;
      if (splitByStatus) {
        this.dailyCountryStatusColumns = [];

        this.dailyCountryStatusColumns.push({
          data: "cc",
          title: "Country",
          rowspan: 2,
        });

        this.countsCountriesPBSP.forEach((cCTTSP, i) => {
          self.dailyCountryStatusColumns.push({
            data: cCTTSP.day,
            title: cCTTSP.day,
            colspan: 4,
          });
          self.dailyCountryStatusColumns.push({
            data: "success",
            title: "Success",
          });
          self.dailyCountryStatusColumns.push({
            data: "failed",
            title: "Failed",
          });
          self.dailyCountryStatusColumns.push({
            data: "timeout",
            title: "Timeout",
          });
          self.dailyCountryStatusColumns.push({
            data: "total",
            title: "Total",
          });
        });

        this.splitByStatusCounts = [];
        for (let obj of this.countriesUnique) {
          let splitByStatusCountObj = {};
          splitByStatusCountObj.cc = obj.cc;
          for (let PBSPObj of this.countsCountriesPBSP) {
            splitByStatusCountObj.success = this.getDayCountStatusSplit(
              PBSPObj.day,
              "All:All",
              obj.cc,
              "success"
            );
            splitByStatusCountObj.failed = this.getDayCountStatusSplit(
              PBSPObj.day,
              "All:All",
              obj.cc,
              "failure"
            );
            splitByStatusCountObj.timeout = this.getDayCountStatusSplit(
              PBSPObj.day,
              "All:All",
              obj.cc,
              "timeout"
            );
            splitByStatusCountObj.total = this.getDayCountStatusSplit(
              PBSPObj.day,
              "All:All",
              obj.cc,
              "_"
            );
          }
          this.splitByStatusCounts.push(splitByStatusCountObj);
        }
        this.filteredSplitByStatusCount = this.splitByStatusCounts.filter((obj) => {
          return typeof obj.total !== "undefined" && obj.total !== null;
        });

        this.showsplitByStatusTable = true;
      } else {
        this.showsplitByStatusTable = false;
      }
    },

    getDayCountStatusSplit(date, pd, cc, status) {
      let d = date.replace(/-/g, "");
      let key = d + pd + cc + status;
      return this.countriesPBLatency[key];
    },

    loadPidCount() {
      let self = this;
      let s = this.today,
        e = this.today,
        query_name = this.cid + "_counts_by_pid",
        query_params =
          'where=[{"key":"event_date","op":">=","val":[' +
          s +
          ']},{"key":"event_date","op":"<=","val":[' +
          e +
          "]}]";

      if (this.reportType == "partner") {
        query_params +=
          "&select=event_date AS Date, pid AS Pid, host_name " +
          "AS HostName, tag_type AS TagType, sum(counts) AS Counts" +
          "&groupby=GROUP BY event_date,pid,host_name,tag_type";
      } else {
        query_name = this.cid + "_counts_cc_by_pid";
        query_params +=
          "&select=event_date AS Date, pid AS Pid, host_name " +
          "AS HostName, country_code AS CC, tag_type AS TagType, counts AS Counts";
      }
      axios
        .post(
          this.$store.state.pailUrl +
            `/${this.$store.state.pailVersion}/cids/` +
            this.cid +
            "/named_queries/" +
            query_name +
            "/execute?" +
            encodeURI(query_params)
        )
        .then(function (response) {
          var query_id = response.data.query_execution_id;
          this.loadingPidData = true;
          if (this.$store.state.environment === "test") {
            switch (this.reportType) {
              case "partner":
                this.pidCounts = [];
                query_id = "pidReport";
                break;
              case "countries":
                this.pidCcCounts = [];
                query_id = "pidCCReport";
                break;
            }
            self.sleep(100).then(function () {
              self.getQueryData(query_id, 120);
            });
          } else {
            if (query_id != "" && query_id != undefined) {
              self.sleep(2000).then(function () {
                self.getQueryData(query_id, 120);
              });
            } else {
              alert("Failed to submit query on athena, please contact support...");
              self.loadingPidData = false;
            }
          }
        })
        .catch((error) => {
          if (error.response.data.error) self.error = error.response.data.error;
          else if (error.response.data.message) self.error = error.response.data.message;
          else self.error = error.message;
        });
    },

    getQueryData(query_id, counter) {
      let self = this;
      axios
        .get(
          this.$store.state.pailUrl +
            `/${this.$store.state.pailVersion}/cids/` +
            this.cid +
            "/query_executions/" +
            query_id
        )
        .then(function (response) {
          if (response.data.message) {
            var errMsg = JSON.stringify(response.data.message);
            if (
              (errMsg.includes("QUEUED") || errMsg.includes("RUNNING")) &&
              counter > 0
            ) {
              counter--;
              self.sleep(5000).then(function () {
                self.getQueryData(query_id, counter, self.cid);
              });
            } else {
              self.loadingPidData = false;
            }
          } else {
            self.loadingPidData = false;
            if (self.getPidCounts) {
              if (response.data.partial_result) {
                axios
                  .get(
                    self.$store.state.pailUrl +
                      `/${self.$store.state.pailVersion}/cids/` +
                      self.cid +
                      "/query_result_file/" +
                      query_id
                  )
                  .then(function (resp) {
                    var data = resp.data.replace(/"/g, "").split("\n");
                    var column_info = data.shift().split(",");
                    switch (self.reportType) {
                      case "partner":
                        self.pidCounts = self.convertToTableJson({
                          column_info: column_info,
                          data: data,
                        });
                        break;
                      case "countries":
                        self.pidCcCounts = self.convertToTableJson({
                          column_info: column_info,
                          data: data,
                        });
                        break;
                    }
                  });
              } else {
                switch (self.reportType) {
                  case "partner":
                    self.pidCounts = self.convertToTableJson(response.data);
                    break;
                  case "countries":
                    self.pidCcCounts = self.convertToTableJson(response.data);
                    break;
                }
              }
            } else {
              self.pidCounts = [];
              self.pidCcCounts = [];
            }
          }
        })
        .catch((error) => {
          if (error.response.data.error) self.error = error.response.data.error;
          else if (error.response.data.message) self.error = error.response.data.message;
          else self.error = error.message;
        });
    },

    convertToTableJson(obj) {
      var c = [];
      for (var i = 0; i < obj.data.length; i++) {
        var temp = {};
        for (var j = 0; j < obj.column_info.length; j++) {
          if (obj.column_info[j].name == "Counts") {
            temp[obj.column_info[j].name] = parseInt(obj.data[i][j]) | 0;
          } else {
            temp[obj.column_info[j].name] = obj.data[i][j];
          }
        }
        c.push(temp);
      }
      return c;
    },

    sleep(time) {
      return new Promise(function (resolve) {
        setTimeout(resolve, time);
      });
    },

    mergeCounts(src, pkey, skey) {
      let uniqKeys = {};
      let dupKeys = {};
      for (let i = 0; i < src.length; i++) {
        if (uniqKeys[src[i][pkey]]) {
          if (src[i][skey] == "NA" || src[i][skey] == uniqKeys[src[i][pkey]][skey]) {
            uniqKeys[src[i][pkey]].count += src[i].count;
            dupKeys[uniqKeys[src[i][pkey]][pkey] + ":" + uniqKeys[src[i][pkey]][skey]] =
              src[i][pkey] + ":" + src[i][skey];
            src.splice(i, 1);
            i--;
          } else if (uniqKeys[src[i][pkey]][skey] == "NA") {
            uniqKeys[src[i][pkey]][skey] = src[i][skey];
            uniqKeys[src[i][pkey]].count += src[i].count;
            src.splice(i, 1);
            i--;
          }
        } else {
          uniqKeys[src[i][pkey]] = src[i];
        }
      }
      return dupKeys;
    },

    appendCounts(input, output, keyName, splitKeyname) {
      for (let k in input) {
        let v = {
          count: input[k],
        };
        if (splitKeyname) {
          let m = k.match(/^(([a-z]-[a-z0-9]*)|NA):(.*)$/);
          if (m) {
            v[splitKeyname] = m[1];
            v[keyName] = m[3];
          } else {
            v[splitKeyname] = "NA";
            v[keyName] = k;
          }
        } else {
          v[keyName] = k;
        }
        if (keyName == "partnerDomain" && splitKeyname == "beaconId") {
          v["description"] = this.getBeaconDescription(v[splitKeyname]);
        }
        output.push(v);
      }
    },

    transformCounts(src, dst) {
      for (let tt in src) {
        if (tt in dst) {
          dst[tt] += src[tt];
        } else {
          dst[tt] = src[tt];
        }
      }
    },

    transformDailyCounts(date, src, dst) {
      for (let tt in src) {
        if (tt in dst) {
          dst[tt] += src[tt];
        } else {
          dst[tt] = src[tt];
        }
      }
    },

    mergeDuplicates(dupKeys, dst, key) {
      let self = this;
      if (dst) {
        for (let k in dupKeys) {
          dst.forEach(function (obj) {
            if (obj[key][k] && obj[key][dupKeys[k]]) {
              obj[key][k] = self.mergeObjs(obj[key][k], obj[key][dupKeys[k]]);
            } else if (obj[key][dupKeys[k]]) {
              obj[key][k] = obj[key][dupKeys[k]];
            }
          });
        }
      }
    },

    mergeObjs(src, dst) {
      if (typeof src == "number") {
        src += dst;
      } else if (typeof src == "object") {
        for (var k in src) {
          if (src[k] && dst[k]) {
            src[k] = this.mergeObjs(src[k], dst[k]);
          }
        }
      }
      return src;
    },

    getBeaconDescription(bID) {
      let desc = "";
      let found = false;
      for (let i = 0; i < this.classItems.length; i++) {
        if (found) {
          break;
        }
        let clsObj = this.classItems[i];
        if (!this.currentCls || this.currentCls == clsObj.cls) {
          if (clsObj && clsObj.pixels && clsObj.pixels.items) {
            for (let j = 0; j < clsObj.pixels.items.length; j++) {
              if (clsObj.pixels.items[j].beaconId == bID) {
                found = true;
                desc = clsObj.pixels.items[j].description;
                break;
              }
            }
          }
        }
      }
      return desc;
    },

    exportCSV(sufix, data) {
      if (data && data.length) {
        let fileName = `${this.fromDate}_${this.toDate}_${sufix}`;
        csv.exportCSV(fileName, data);
      }
    },

    updateCountriesPBLatencyCounts(key, count) {
      if (this.countriesPBLatency[key]) {
        this.countriesPBLatency[key] += count;
      } else {
        this.countriesPBLatency[key] = count;
      }
    },

    dateDiffInDays(fromDate, toDate) {
      let hours = dayjs(toDate).diff(dayjs(fromDate), "hours");
      const diffDays = Math.floor(hours / 24);
      return diffDays;
    },

    async aggCounts(
      cls,
      fromDate,
      toDate,
      startHour = "00",
      endHour = "23",
      isCC = false,
      isDailyAgg = false
    ) {
      try {
        let timeRanges = generateDayAndHourAndRawMetricsTimeRanges(
          fromDate,
          toDate,
          startHour,
          endHour,
          isCC
        );
        if (timeRanges.length === 0) {
          return {};
        }
        console.log("timeRanges: ", timeRanges);

        let fetchAllDataForRange = async (range) => {
          if (!range.start_time || !range.end_time || !range.metrics_name) {
            return [];
          }

          let headers = isDailyAgg
            ? isCC
              ? [
                  "time",
                  "tag_type",
                  "partner_domain",
                  "beacon_id",
                  "country_code",
                  "count",
                ]
              : ["time", "tag_type", "partner_domain", "beacon_id", "count"]
            : isCC
            ? ["tag_type", "partner_domain", "beacon_id", "country_code", "count"]
            : ["tag_type", "partner_domain", "beacon_id", "count"];

          let countsPayload = {
            start_time: range.start_time,
            end_time: range.end_time,
            aggregate: true,
            filter_dimensions: {
              cid: this.cid,
            },
            metrics: {
              [range.metrics_name]: {
                version: "1.0.0",
                header: headers,
              },
            },
          };
          if (cls) {
            countsPayload.filter_dimensions.class = cls;
          }
          return getCountsData(
            this.$store.state.countsUrl,
            this.cid,
            this.$store.state.accessToken,
            countsPayload
          );
        };
        let requests = timeRanges.map((range) => fetchAllDataForRange(range));
        let responses = await Promise.all(requests);
        let obj = {
          partnerBeacon: {},
          redirect: {},
          tagType: {},
          ...(isCC && {
            countryCode: {},
            tagType_countryCode: {},
            partnerBeacon_countryCode: {},
          }),
        };
        let countsData = isDailyAgg ? {} : JSON.parse(JSON.stringify(obj));

        responses.flat().forEach((data) => {
          let time, tagType, partnerDomain, beaconId, countryCode, count;
          if (isDailyAgg) {
            if (isCC) {
              [time, tagType, partnerDomain, beaconId, countryCode, count] = data;
            } else {
              [time, tagType, partnerDomain, beaconId, count] = data;
            }
            let date = dayjs(time).format("YYYYMMDD");
            if (!countsData[date]) {
              countsData[date] = JSON.parse(JSON.stringify(obj));
            }
          } else {
            if (isCC) {
              [tagType, partnerDomain, beaconId, countryCode, count] = data;
            } else {
              [tagType, partnerDomain, beaconId, count] = data;
            }
          }
          let target = isDailyAgg
            ? countsData[dayjs(time).format("YYYYMMDD")]
            : countsData;
          if (isCC) {
            if (!target["countryCode"][countryCode]) {
              target["countryCode"][countryCode] = 0;
            }
            target["countryCode"][countryCode] += count;
          }
          if (beaconId === "NA" && partnerDomain === "NA") {
            if (!target["tagType"][tagType]) {
              target["tagType"][tagType] = 0;
            }
            target["tagType"][tagType] += count;
            if (isCC) {
              if (!target["tagType_countryCode"][tagType]) {
                target["tagType_countryCode"][tagType] = {};
              }
              if (!target["tagType_countryCode"][tagType][countryCode]) {
                target["tagType_countryCode"][tagType][countryCode] = 0;
              }
              target["tagType_countryCode"][tagType][countryCode] += count;
            }
          } else if (beaconId !== "NA" && tagType === "partner_beacon") {
            let key = `${beaconId}:${partnerDomain}`;
            if (!target["partnerBeacon"][key]) {
              target["partnerBeacon"][key] = 0;
            }
            target["partnerBeacon"][key] += count;
            if (isCC && isDailyAgg) {
              if (!target["partnerBeacon_countryCode"][key]) {
                target["partnerBeacon_countryCode"][key] = {};
              }
              if (!target["partnerBeacon_countryCode"][key][countryCode]) {
                target["partnerBeacon_countryCode"][key][countryCode] = 0;
              }
              target["partnerBeacon_countryCode"][key][countryCode] += count;
            }
          } else if (partnerDomain !== "NA" && tagType === "302_redirect") {
            let key = `${beaconId}:${partnerDomain}`;
            if (!target["redirect"][key]) {
              target["redirect"][key] = 0;
            }
            target["redirect"][key] += count;
          }
        });
        return sortKeysRecursively(countsData);
      } catch (error) {
        console.error("Error processing aggCounts:", error);
        throw error;
      }
    },

    initiateClass() {
      if (
        this.$store.state.aut.currentClass &&
        this.$store.state.aut.currentClass[this.$store.state.currentClient.cid]
      )
        this.currentCls = this.$store.state.aut.currentClass[
          this.$store.state.currentClient.cid
        ];
        this.currentClsLL = this.$store.state.aut.currentClass[this.$store.state.currentClient.cid];
    },
  },
};
</script>

<style scoped>
.class-menu {
  margin-bottom: 1.5rem;
}
.col-centered {
  float: none;
  margin: 0 auto;
}

.form-check-input:checked {
  background-color: #2c7be5 !important;
  border-color: #2c7be5;
}

.form-check-input {
  background-color: #6e84a3;
}

.spinner-border {
  width: 1em;
  height: 1em;
}

::v-deep(.flatpickr-alt-input) {
    background-color: white !important;
    color: #000 !important;
}
</style>

<style>
body.dark-mode .flatpickr-alt-input {
    background-color: #22252b !important;
    color: #e1e3e8 !important;
}
</style>
